<template>
    <div class="design-panel-container">
        <Toolbar :designProps="designProps"/>
        <div class="display-flex design-panel-container-height">
            <my-panel />
            <!-- <div style="background: white;" class="display-flex-column width-20">
                <div v-for="(value, key) in handlePanelElementList"
                     @click="clickHandlePanelIcon(key)"
                     :class="['my-icon handle-panel-icon iconfont',{'handle-panel-icon-active': configStore.settingPanel[key].visible}, value.icon]"
                     :key="key" />
                <history-panel />
                <operation-panel />
                <setting-panel />
            </div> -->
            <minimap-panel />
        </div>
        <div class="design-panel-footer">
          <!-- <el-button v-repeat type="primary" @click="submit('')">保存</el-button>
          <el-button @click="closeDrawer()">取消</el-button> -->
          <el-button v-repeat type="primary">保存</el-button>
          <el-button>取消</el-button>
        </div>
    </div>
</template>

<script setup lang="ts">
import Toolbar from '@myprint/design/components/content/toolbar/toolbar.vue';
import MyPanel from './my-panel.vue';
// import { handlePanelElementList } from '@myprint/design/constants/settingPanel';
// import HistoryPanel from '../handle-panel/history-panel.vue';
// import OperationPanel from '../handle-panel/operation-panel/index.vue';
// import SettingPanel from '../handle-panel/setting/setting-panel.vue';
import { useConfigStore } from '@myprint/design/stores/config';
import MinimapPanel from '@myprint/design/components/content/handle-panel/minimap-panel.vue';
//@ts-ignore
import { DesignPanelProps } from '@myprint/design/types/entity';

withDefaults(defineProps<{
    designProps: DesignPanelProps;
}>(), {

});
const configStore = useConfigStore();

function clickHandlePanelIcon(key: any) {
    configStore.settingPanel[key].visible = !configStore.settingPanel[key].visible;
}

</script>

<!-- <style scoped>
:deep(.el-button) {
  border-radius: 4px;
  background: #CFCFCF;
  height: 54px;
  color: #0000004C;
  font-size: 24px;
  margin-top: 20px;
  float: right;
  margin-right: 40px;
  width: 108px;
}
:deep(.el-button--primary) {
  background: #2951D5;
  color: #FFFFFF;
}
</style> -->
